<template>
  <div>
    <el-form style="height: 99%; position: absolute; width: 100%"
      :style="{ padding: pageStates == 'view' ? '20px 60px' : '' }" :inline="true" :model="peopleInfo"
      :rules="pageStates == 'view' ? {} : rules" ref="refForm" label-width="110px" label-position="right"
      label-suffix=" ：">
      <el-scrollbar style="height: 100%">
        <div style="display: flex">
          <div style="width: 73%">
            <el-col :span="24">
              <el-form-item label="账户" prop="accountNumber">
                <span v-if="pageStates == 'view'">{{ peopleInfo.accountNumber }}</span>
                <el-input v-else v-model="peopleInfo.accountNumber" clearable
                  :disabled="pageStates == 'add' ? false : true" placeholder="请输入账户名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="类型" prop="accountType">
                <span v-if="pageStates == 'view'">
                  {{ peopleInfo.accountType && accountType[peopleInfo.accountType - 1].label }}</span>
                <el-select v-else :disabled="pageStates != 'add' && !isEditAccoutType" v-model="peopleInfo.accountType"
                  placeholder="请选择账户类型" @change="accountTypeChange">
                  <el-option v-for="item in accountType" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="peopleInfo.accountType == 2 && pageStates != 'view'">
              <span style="color: red; margin-left: 110px;">当类型为员工时，请点击姓名输入框右侧<span style="font-weight: bold;"> ···
                </span>按钮选择人员</span>
            </el-col>
            <el-col :span="24">
              <el-form-item label="姓名" prop="nickName">
                <span v-if="pageStates == 'view'">{{ peopleInfo.nickName }}</span>
                <el-input v-else v-model="peopleInfo.nickName" placeholder="请输入姓名" clearable
                  :disabled="peopleInfo.accountType == 2"></el-input>
                <img style="cursor: pointer; position: absolute; top: 10px; right: 10px"
                  src="@src/common/assets/images/icon/more.png" @click="openChoosePeople"
                  v-if="(peopleInfo.accountType == 2 || peopleInfo.accountType == 3 || peopleInfo.accountType == 4) && pageStates != 'view'"
                  alt="" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="性别" prop="sex">
                <span v-if="pageStates == 'view'">{{ sexTypeRender(peopleInfo.sex) }}</span>
                <el-select v-else v-model="peopleInfo.sex" placeholder="请选择" :disabled="peopleInfo.accountType == 2">
                  <el-option v-for="item in sexType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="手机号" prop="phone">
                <span v-if="pageStates == 'view'">{{ peopleInfo.phone }}</span>
                <el-input v-else clearable autocomplete="off" v-model="peopleInfo.phone" placeholder="请输入手机号码"
                  :disabled="peopleInfo.accountType == 2"></el-input>
              </el-form-item>
            </el-col>
          </div>
          <div>
            <el-form-item label="" prop="fileCode">
              <el-col :span="24">
                <el-upload action v-if="!fileList.length" :file-list="fileList" ref="accountUpload"
                  :show-file-list="false" :list-type="'picture-card'" accept="image/png, image/jpg, image/jpeg, image/bpm"
                  :auto-upload="false" :multiple="false" :limit="1" :on-change="onChangeFile" :on-remove="onRemoveFile">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="imgFile" v-else>
                  <img :src="imageUrl" @click="showViewer" :class="pageStates == 'view' ? 'viewImg' : 'uploadImg'"
                    @error="showError" />
                  <div class="delete-icon" v-if="pageStates != 'view'">
                    <i class="el-icon-delete" @click="onRemoveFile"></i>
                  </div>
                </div>
              </el-col>
            </el-form-item>
          </div>
        </div>
        <!-- <el-col :span="24">
          <el-form-item label="园区" prop="parkId">
            <span v-if="pageStates == 'view'">{{ peopleInfo.parkName }}</span>
            <el-cascader v-else clearable :disabled="pageStates == 'add' ? false : true" v-model="peopleInfo.parkId"
              :show-all-levels="false" :options="parkType" placeholder="请选择所属园区" style="width: 100%;" :props="{
                expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'parkName', value: 'parkId',
                children: 'childrens',
              }" />
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="工作组" prop="securityWorkGroupCode">
            <span v-if="pageStates == 'view'">{{ securityWorkGroupName }}</span>
            <el-select v-else v-model="peopleInfo.securityWorkGroupCode" multiple placeholder="请选择" @change="$forceUpdate()"
              :disabled="pageStates == 'view'">
              <el-option v-for="item in workGroupArr" :key="item.securityWorkGroupCode"
                :label="item.securityWorkGroupName" :value="item.securityWorkGroupCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="pageStates == 'add'">
          <el-form-item label="密码" prop="password">
            <el-input type="password" auto-complete="new-password" v-model="peopleInfo.password"
              placeholder="请输入密码"></el-input>
            <el-tooltip effect="dark" placement="top-end">
              <div slot="content">
                <ul style="line-height: 20px">
                  <li>● 长度在{{ rules.password[1].max }}个字符</li>
                  <li>● 格式【{{ codeTypeArray[codeType - 1].label }}】</li>
                </ul>
              </div>
              <el-button type="text" icon="iconfont icon-Question" style="position: absolute; top: 0px; right: 0px">
              </el-button>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="pageStates == 'add'">
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input clearable auto-complete="new-password" type="password" v-model="peopleInfo.confirmPassword"
              placeholder="请输入确认密码">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="邮箱" prop="email">
            <span v-if="pageStates == 'view'">{{ peopleInfo.email }}</span>
            <el-input clearable v-else v-model="peopleInfo.email" placeholder="默认地址:example@example.com"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="desc">
            <span v-if="pageStates == 'view'">{{ peopleInfo.desc }}</span>
            <el-input maxlength="200" show-word-limit v-else clearable type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }" v-model="peopleInfo.desc" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色" prop="role">
            <div v-if="pageStates == 'view'">
              <div v-for="item in reservedAccount" :key="item.accountGroupCode">
                {{ item.accountGroupName }}
                <span v-if="item.beginTime">
                  | 有效期：{{ item.date[0] }} 至
                  {{ item.date[1] }}
                </span>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="pageStates != 'view'">
          <IocTransfer style="margin: -5px 30px" ref="iocTransfer" :value="reservedAccount" :data="transferList"
            :props="transferProps" type="date" :filterable="false"
            :titles="[$t('account.title.selectableRole'), $t('account.title.selectedRole')]" @changeData="changeData">
          </IocTransfer>
        </el-col>
        <el-col :span="24" v-if="pageStates == 'view' && buildManage != ''">
          <el-form-item label="管理冷库">
            <span>{{ buildManage }}</span>
          </el-form-item>
        </el-col>
      </el-scrollbar>
    </el-form>
    <!-- 人员选择弹框 -->
    <el-dialog title="人员选择" :append-to-body="true" :visible.sync="dialogPeople" width="48%" class="choose-container">
      <div style="height: 650px;">
        <ioc-table ref="personTable" :data="personData" :option="personOption" :page="personPage"
          @size-change="personChangeSize" @current-change="currentChange" @search-change="searchList"
          @search-reset="personReset" @radio-change="personRadio">
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">{{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 2">{{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{ statusFormatter(scope.row) }}</span>
          </template>
        </ioc-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import sha256 from "@src/common/lib/sha";
import utils from "@src/common/utils";
import IocTransfer from "@src/components/common/ioc-component/ioc-transfer";
import personOption from "../const/crud/personOptions";

const resetForm = () => {
  return {
    accountNumber: "",
    nickName: "",
    accountType: "",
    // sex: 0,
    sex: "",
    password: "",
    confirmPassword: "",
    phone: "",
    email: "example@example.com",
    // parkName: "",
    parkId: "",
    fileCode: "",
    desc: "",
    role: "",
  };
};
export default {
  components: {
    IocTransfer,
  },
  props: {
    pageStates: {
      type: String,
      default: "add",
    },
    isEditAccoutType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateEmails = (rule, value, callback) => {
      // var reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$')
      var reg = new RegExp(
        "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
      );
      if (!reg.test(value)) {
        callback(new Error("邮箱格式不正确"));
      } else if (value.indexOf("@") > 18 || value.indexOf("@") < 4) {
        callback(new Error("邮箱前缀为 4 到 18 个字符"));
      } else {
        callback();
      }
    };

    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    const validateName = (rule, value, callback) => {
      var reg = new RegExp("^[a-zA-Z][0-9a-zA-Z_]+$");
      if (!reg.test(value)) {
        callback(new Error("名称由数字、字母、下划线组成，且首字符为字母"));
      } else {
        callback();
      }
    };
    return {
      imageUrl: "",
      fileList: [],
      transferProps: {
        key: "accountGroupCode",
        label: "accountGroupName",
      },
      reservedAccount: [],
      transferList: [],
      personSearch: {},
      dialogPeople: false,
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personData: [],
      personOption: personOption(),
      peopleInfo: resetForm(),
      rules: {
        accountNumber: [
          {
            required: true,
            message: "请输入账户名称",
            trigger: ["blur", "change"],
          },
          {
            min: 4,
            max: 30,
            message: "长度在 4 到 30 个字符",
            trigger: "blur",
          },
          {
            validator: validateName,
            trigger: "blur",
          },
        ],
        nickName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
          {
            min: 1,
            max: 50,
            message: "姓名长度在 1 到 50 个字符",
            trigger: "change",
          },
        ],
        accountType: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["blur", "change"],
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("base.message.newPwd"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 6,
            message: "密码长度为6个字符",
            trigger: ["blur", "change"],
          },
          { validator: this.validatePwd, trigger: ["blur"] },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur", "change"],
          },
          {
            validator: this.validatePass,
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            validator: validatePhone,
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: ["blur", "change"],
          },
          {
            min: 6,
            max: 64,
            message: "长度在 6 到 64 个字符",
            trigger: "blur",
          },
          {
            validator: validateEmails,
            trigger: "blur",
          },
        ],
        // parkName: [
        //   {
        //     required: true,
        //     message: "请选择园区",
        //     trigger: "change",
        //   },
        // ],
        // parkId: [
        //   {
        //     required: true,
        //     message: "请选择园区",
        //     trigger: "change",
        //   },
        // ],
        fileCode: [
          {
            required: true,
            message: "请上传图片",
            trigger: ["change"],
          },
        ],
      },
      accountType: [
        {
          label: "其他",
          value: "1",
        },
        {
          label: "员工",
          value: "2",
        },
        // {
        //   label: "库管",
        //   value: "3",
        // },
        // {
        //   label: "门卫",
        //   value: "4",
        // },
      ],
      parkType: [],
      sexType: utils.Dic.find("SENU092"),
      // sexType: [
      //   { label: '男', value: 1 },
      //   { label: '女', value: 0 },
      // ],
      accountGroupList: [],
      codeType: 2,
      checkPeopleInfo: null,
      codeTypeArray: [
        {
          label: "任意字符",
          value: 1,
        },
        {
          label: "字母+数字混和",
          value: 2,
        },
        {
          label: "大写字母+小写字母+数字混合",
          value: 3,
        },
      ],
      // 工作组
      workGroupArr: [],
      securityWorkGroupName: '',
      // 管理冷库
      buildManage: ''
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
    // this.getPersonList(); //人员列表
    this.getSyConfig(); //密码配置
    this.handleAddAccount(); //角色权限
    this.querySecurityWorkGroup(); //查询工作组
  },
  methods: {
    sexTypeRender(value) {
      if (value == 1) {
        return '男'
      } else if (value == 2) {
        return '女'
      } else {
        return ''
      }
    },
    accountTypeChange() {
      if (this.peopleInfo.accountType == 2) {
        this.peopleInfo.nickName = ''
        this.peopleInfo.sex = ''
        this.peopleInfo.phone = ''
      }
    },
    querySecurityWorkGroup() {
      this.$fetch(api.group.querySecurityWorkGroup, {}).then((res) => {
        if (res.success) {
          this.workGroupArr = res.returnObj[0].securityWorkGroupChildren
        }
      });
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    showError() {
      this.imageUrl = "/images/theme/newDark/default.png";
      this.peopleInfo.fileCode = "";
      this.$message.error("人员图片获取失败，重新上传！");
    },
    getAccountRule(info) {
      this.$fetch(api.account.queryRlatAcctGroup, { accountNumber: info.accountNumber, }).then((res) => {
        if (res.success) {
          this.reservedAccount = res.returnObj.map((item) => {
            if (item.beginTime === undefined || item.endTime === undefined) {
              item.beginTime = "";
              item.endTime = "";
            }
            return {
              ...item,
              date: [item.beginTime, item.endTime],
            };
          });
        }
      });
    },
    handleSetForm(info) {
      this.accountDetail(info)
      this.getAccountRule(info);
      this.peopleInfo = {
        ...info,
      };
      this.fileList.push({
        url: this.getImgPath(this.peopleInfo.fileCode),
        status: "update",
        fileCode: this.peopleInfo.fileCode,
      });
      this.$refs.refForm.clearValidate();
      this.imageUrl = utils.Bus.imgPath(this.peopleInfo.fileCode);
      delete this.peopleInfo.accountGroupList;
      delete this.peopleInfo.password;
      delete this.peopleInfo.confirmPassword;
      // console.log(this.peopleInfo);
    },
    // 账户详情查询
    accountDetail(info) {
      this.$fetch(api.account.queryAccountDetail, { "accountNumber": info.accountNumber }).then((res) => {
        if (res.success) {
          const dataArr = res.returnObj.securityWorkGroupLists.map(item => {
            return item.securityWorkGroupCode
          })
          this.peopleInfo.securityWorkGroupCode = dataArr
          const dataLabelArr = res.returnObj.securityWorkGroupLists.map(item => {
            return item.securityWorkGroupName
          })
          this.securityWorkGroupName = dataLabelArr.join(',')
          if (res.returnObj.buildingLists.length > 0) {
            let buildArr = res.returnObj.buildingLists.map(item => {
              return item.buildingName
            })
            this.buildManage = buildArr.join(',')
          } else {
            this.buildManage = ''
          }
        }
      });
    },
    handleRestForm() {
      this.fileList = [];
      this.imageUrl = "";
      this.reservedAccount = [];
      this.peopleInfo = resetForm();
      // this.$refs.refForm.resetFields();
      this.$nextTick(() => {
        this.$refs["refForm"].clearValidate();
      });
    },
    handleAddAccount() {
      const params = {
        pageNo: 1,
        pageSize: 1000,
        accountGroupName: "",
      };
      this.$fetch(api.account.queryAccGroup, params).then((resp) => {
        if (resp.success) {
          this.transferList = resp.returnObj.list;
        }
      });
      this.reservedAccount = [];
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t("base.message.againPwd")));
      } else if (value !== this.peopleInfo.password) {
        callback(new Error(this.$t("base.message.diffPwd")));
      } else {
        callback();
      }
    },
    validatePwd(rule, value, callback) {
      let reg = "";
      if (this.codeType == 2) {
        // 数字+任意英文
        // reg = new RegExp("^((?=.*\\d)(?=.*[A-Za-z]))[0-9a-zA-Z]*$");
        reg = new RegExp("^((?=.*\\d)(?=.*[A-Za-z]))[0-9a-zA-Z]*$");
      } else if (this.codeType == 3) {
        //数字+英文(大写+小写)
        reg = new RegExp("^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$");
      } else {
        //任意密码
        callback();
        return;
      }
      if (!reg.test(value) && value != this.peopleInfo.accountNumber) {
        callback(new Error("密码格式为:" + this.codeTypeArray[this.codeType - 1].label));
      } else {
        callback();
      }
    },
    getSyConfig() {
      let params = {
        cfgCode: "PASSWORD_FORMAT,PASSWORD_LENGTH",
        pageNum: 1,
        pageSize: 10,
      };
      this.$fetch(this.$api.common.querySysConfig, params).then((res) => {
        if (res.success) {
          this.codeType = Number(res.returnObj.list[0].cfgValue); //3
          this.rules.password[1].max = +res.returnObj.list[1].cfgValue;
          this.rules.password[1].min = +res.returnObj.list[1].cfgValue;
          this.rules.password[1].message =
            "密码长度为" + this.rules.password[1].max + "位字符";
        }
      });
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = ["jpg", "png", "jpeg", "bpm", "JPG", "PNG", "JPEG", "BPM"];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);
      if (!isJPG) {
        this.$message.error(this.$t("videoPatrol.message.sizePicture"));
        return false;
      }
      return true;
    },
    onChangeFile(file, fileList) {
      if (!this.validImg(file)) {
        this.imageUrl = "";
        this.fileList = [];
        return false;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.fileList = fileList;
      this.peopleInfo.fileCode = "add";
      this.$refs.refForm.clearValidate("fileCode");
    },
    onRemoveFile(file, fileList) {
      this.$confirm("确认要删除图片吗？", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.imageUrl = "";
        this.fileList = [];
        this.peopleInfo.fileCode = "";
      });
    },
    // 角色变化回调
    changeData(data) {
      // console.log(data);
      // this.accountGroupList = data;
      this.accountGroupList = data.map((item) => {
        return {
          accountGroupCode: item.accountGroupCode,
          beginTime:
            item.date && item.date[0]
              ? this.$utils.Dates.format(item.date[0], "yyyy-MM-dd") + " 00:00:00"
              : "",
          endTime:
            item.date && item.date[1]
              ? this.$utils.Dates.format(item.date[1], "yyyy-MM-dd") + " 23:59:59"
              : "",
        };
      });
    },
    personRadio(item) {
      this.checkPeopleInfo = item;
    },
    // 人员取消
    cancelChoose() {
      this.dialogPeople = false;
      this.checkPeopleInfo = null;
      this.$refs.personTable.templateRadio = "";
    },
    // 人员确定
    confirmChoose() {
      if (!this.checkPeopleInfo) {
        this.$message.warning("请选择人员");
        return;
      }
      this.fileList = [];
      this.imageUrl = "";
      this.peopleInfo.personnelCode = this.checkPeopleInfo.personnelCode; //人员Id
      this.peopleInfo.nickName = this.checkPeopleInfo.name;
      this.peopleInfo.sex = Number(this.checkPeopleInfo.sex);
      this.peopleInfo.phone = this.checkPeopleInfo.phone;
      this.peopleInfo.fileCode = this.checkPeopleInfo.facePicFileCode; //利用已有人员
      this.fileList.push({
        url: this.getImgPath(this.checkPeopleInfo.facePicFileCode),
        status: "update",
        fileCode: this.checkPeopleInfo.facePicFileCode,
      });
      this.$refs.refForm.clearValidate("fileCode");
      this.imageUrl = utils.Bus.imgPath(this.checkPeopleInfo.facePicFileCode);
      // this.dialogPeople = false;
      // this.$refs.personTable.templateRadio = '';
      this.cancelChoose();
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    statusFormatter(data) {
      switch (data.status * 1) {
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.status;
      }
    },
    // 获取人员选择弹框中人员列表
    // getPersonList() {
    //   const params = {};
    //   params.personnelType = 1;
    //   params.workNo = this.personSearch.workNo;
    //   params.name = this.personSearch.name;
    //   params.pageNum = this.personPage.pageNum;
    //   params.pageSize = this.personPage.pageSize;
    //   this.$fetch(api.account.getPersonList, params).then((response) => {
    //     if (!response.success) {
    //       this.$message.error(response.msgContent);
    //       return;
    //     }
    //     this.personData = response.returnObj
    //       ? Object.freeze([...response.returnObj.list])
    //       : [];
    //     this.personPage.total = response.returnObj ? response.returnObj.total : 0;
    //   });
    //   // response.returnObj.list.forEach((el, index) => {
    //   //         // if (el.personnelCode == this.personnelCode) {
    //   //         //   this.$refs.multipleTable.templateRadio = index;
    //   //         // }
    //   //       });
    //   // this.$refs.personTable.templateRadio = '';
    // },
    getPersonList() {
      const params = {};
      params.personnelType = 1;
      params.workNo = this.personSearch.workNo;
      params.name = this.personSearch.name;
      params.pageNum = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      this.$fetch(api.account.getPersonListNew, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj ? response.returnObj.total : 0;
      });
    },
    // 员工弹框修改每页数据数量
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.getPersonList();
    },
    openChoosePeople() {
      this.dialogPeople = true;
      // console.info("3333333=====",this.peopleInfo)
    },
    submit() {
      this.$refs.refForm.validate((res) => {
        if (res) {
          let params = { ...this.peopleInfo };
          delete params.role;
          if (!params.id) {
            params.password = sha256.SHA256(params.password);
            params.confirmPassword = sha256.SHA256(params.confirmPassword);
          }
          // const list = this.accountGroupList.map((item) => {
          //   let beginTime = "",
          //     endTime = "";
          //   if (item.date && item.date.length) {
          //     item.date = [
          //       utils.Dates.parse(utils.Dates.format(item.date[0])),
          //       utils.Dates.parse(utils.Dates.format(item.date[1])),
          //     ];
          //     beginTime = utils.Dates.format(_.result(item, "date[0]", Date()));
          //     endTime = utils.Dates.format(_.result(item, "date[1]", Date()));
          //   }
          //   return {
          //     accountGroupCode: item.accountGroupCode,
          //     beginTime: beginTime,
          //     endTime: endTime && endTime.split(" ")[0] + " 23:59:59",
          //   };
          // });
          params.accountGroupList = [...this.accountGroupList];
          // if (params.accountType == 1) {
          //   delete params.personnelCode;
          // }
          if (
            (!this.peopleInfo.fileCode || this.peopleInfo.fileCode == "add") &&
            this.fileList.length
          ) {
            let formData = new FormData();
            this.fileList.map((item) => {
              formData.append("files", item.raw);
            });
            this.$fetch(api.account.batchFileload, formData).then((res) => {
              params.fileCode = res.returnObj[0].fileId;
              this.$emit("save-people-info", params);
            });
          } else {
            this.$emit("save-people-info", params);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep .el-upload--picture-card {
  width: 85%;
  margin: 5px 0px 0;
  height: 175px;
  line-height: 175px;
}

.el-form-item {
  width: 100%;
  display: flex;

  :deep .el-form-item__content {
    width: calc(100% - 125px);
  }

  :deep .el-upload--picture-card {
    width: 180px;
    height: 175px;
    // background: #0d121c;
  }

  .el-input__inner {
    width: 100%;
  }
}

.imgFile {
  // display: flex;
  // width: 148px;
  height: 185px;
  position: relative;

  .viewImg {
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  .uploadImg {
    margin: 5px 0;
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  &:hover {
    .delete-icon {
      opacity: 1;
    }
  }

  .delete-icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 0;
    width: 180px;
    height: 177px;
    border-radius: 6px;
    opacity: 0;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}
</style>
